import {h, Fragment} from "preact"
import { usePagination, useActions } from '@nosto/preact'
import { isFrench } from '../config'

export default () => {
    const pagination = usePagination({
        width: 5
    })
    const { updateSearch } = useActions()

    const createCallback = (from) => () => {
        updateSearch({
            products: {
                from,
            },
        })
        scrollTo(0, 0)
    }

    return (
        <div class="ns-pagination flex justify-between">
            <div>
                {pagination.prev
                    ?   <button type="button" aria-label="Previous" class="ns-previous" onClick={createCallback(pagination.prev.from)}>{isFrench ? 'Précédent' : 'Prev'}</button>
                    :   <button type="button" aria-label="Previous" class="ns-previous" disabled>{isFrench ? 'Précédent' : 'Prev'}</button>
                }
            </div>

            <div class="ns-pagination-container flex">
            {pagination.pages[0]?.page > 1 && (
                <button
                    type="button"
                    class="ns-page-link"
                    onClick={createCallback(0)}
                >
                    1
                </button>
            )}

                {pagination.first && <div>...</div>}
                {pagination.pages.map((page) => (
                    <button type="button" class={`ns-page-link ${page.current ? 'ns-active' : ''}`} onClick={createCallback(page.from)}>
                        {page.page}
                    </button>
                ))}
                {pagination.last && <div>...</div>}
                {pagination.last && (
                    <button
                        type="button"
                        class="ns-page-link"
                        onClick={createCallback(pagination.last.from)}
                    >
                        {pagination.totalPages}
                    </button>
                )}
            </div>

            <div>
                {pagination.next 
                    ?   <button type="button" aria-label="Next" class="ns-next" onClick={createCallback(pagination.next.from)}>{isFrench ? 'Suivant' : 'Next'}</button>
                    :   <button type="button" aria-label="Next" class="ns-next" disabled>{isFrench ? 'Suivant' : 'Next'}</button>
                }
            </div>
        </div>
    )
}
